const baseURL = import.meta.env.VITE_BASEURL;
export default baseURL;
